import { of } from 'rxjs';
import { firestore } from '../../../functions/firebase/firebaseAccess';
import {
  collectionQuery,
  WithID,
} from '../../../functions/firebase/rxfireExtensions';
import { useObservable } from '../../../functions/hooks/useObservable';
import { isSellerProfile } from '../../../functions/models/profiles';
import { Profile } from '../../../models/ClientModels';

export const useStorFavoritesListingCount = (
  profile: WithID<Profile>,
  limit: number,
  ignored?: boolean,
) => {
  const storeId = profile.id;
  const isSeller = profile != null && isSellerProfile(profile);
  const listings = useObservable(
    () =>
      isSeller && !ignored
        ? collectionQuery(
            firestore()
              .collection('stores')
              .doc(storeId)
              .collection('publicListings')
              .limit(Math.max(limit, 1)),
          )
        : of(undefined),
    `store:${storeId}:recent-${limit}-public-listings${
      ignored ? ':ignored' : ''
    }`,
  );
  return listings?.size ?? 0;
};
